import React from "react";
import Password from "../../UI/Password";
import Icon from "../../../../assets/icons/Icon";

const GlobalSettingUpdateModal = ({
  rowData,
  updateAll,
  handleShowHide,
  handleFn,
}) => {
  // console.log("rowData========", rowData);
  return (
    <>
      <div className="heading_market heading_market--subpage">
        <div className="content_text">
          <h2 className="content_text__eyebrow d-flex align-items-center gap-1 flex-wrap">
            <span>{rowData?.eventTypeName}</span>
            <Icon name="ChevronRight" size={13} />
            <span className="menu-text text-primary">
              {rowData?.bettingTypeName}
            </span>
          </h2>
        </div>
      </div>

      <Password
        onCancel={handleShowHide}
        onConfirm={() => handleFn(rowData, updateAll)}
      />
    </>
  );
};

export default GlobalSettingUpdateModal;
